import React from "react";
import {GetUserToken} from "../../../../api/token";
import {PostToPbx} from "../../../../api/http-post";
import Connector from "../../../../redux/connector";
import store from '../../../../redux/store';
import PbxServer from "./PbxServer";
import {SocketContext} from '../../../../websocket/Context';
import {fetchDataEntity} from "../../../../api/entity-data";

class BackendSocket extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Reminders: [],
            UserVoips: [],
        }

    }

    componentDidMount = async () => {
        await this.loadInitialData();
    }

    /**
     *
     * Reminders
     */
    loadInitialData = async () => {
        await this.loadData("Reminders", "Reminders", (data) => this.setReminderRedux(data));
        await this.loadData("AllocationUserViop", "UserVoips", (data) => this.setUserVoipInfo(data));
    }
    loadData = async (targetEntity, stateKey, feedback) => {
        let _this = this;
        let userInfo = GetUserToken();
        let table = targetEntity;
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = {}
        post.Entity = table;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })

        await PostToPbx(post, endpoint, async (data) => {
            console.log("BackendSocket loadData loadInitialData response > ", post, " > ", data);
            await _this.setState({
                [stateKey]: data.RESULT
            })
            feedback(data.RESULT);
        });
    }
    setReminderRedux = (data) => {
        console.log("BackendSocket setReminderRedux >  ", data);
        if (data === null) {
            return
        }
        if (data === undefined) {
            return
        }
        this.props.SaveReminder(data);
    }
    /**
     *
     * Call by browser
     */
    setUserVoipInfo = (voips) => {
        let userInfo = GetUserToken();
        let info = null;
        console.log("setUserVoipInfo > ",voips)
        for (let i in voips) {
            let row = this.state.UserVoips[i];
            if (row.user === userInfo.Username) {
                info = row;
            }
        }

        if (info === null) {
            return
        }

        const server = "voip2.easipath.com";
        const username = info.extension;
        const secret = info.secret;
        console.log("2 (((--->? ",server, username, " > ", info);
        this.props.PbxChangeExtension({
            username: username,
            secret: secret + username,
            server: server,
        });

    }
    getInfo = () => {
        let userInfo = GetUserToken();
        let extension = "", project = "", name = userInfo.FullName, email = userInfo.Username, phone = userInfo.Phone,
            org = userInfo.Org;
        for (let i in this.state.UserProjects) {
            let row = this.state.UserProjects[i];
            if (row.user === userInfo.Username) {
                project = row.project;
            }
        }
        for (let i in this.state.UserVoips) {
            let row = this.state.UserVoips[i];
            if (row.user === userInfo.Username) {
                extension = row.extension;
            }
        }

        return {extension, project, name, email, phone, org}

    }

    render() {
        return (
            <SocketContext.Provider value={{
                prices: this.state.prices
            }}>
                <div style={{minWidth: "100%", minHeight: "100%"}}>
                    {this.props.children}
                    <PbxServer/>
                </div>
            </SocketContext.Provider>
        )

    }
}

export default Connector(BackendSocket);
